/** The Analytics summary card represents the whole site, not filtered rows. */
export const getWaterTreesSummaryCount = (
  unfilteredTotal: number,
  fallbackTotal = 0
): number => Number.isFinite(unfilteredTotal) && unfilteredTotal >= 0
  ? unfilteredTotal
  : fallbackTotal
